export class InvalidGeoJsonError extends Error {
    constructor(message: string) {
        super(message);
        this.name = "InvalidGeoJsonError";
        // This is necessary for proper stack traces in TypeScript
        Object.setPrototypeOf(this, InvalidGeoJsonError.prototype);
    }
}
